import moment, { Moment } from 'moment-timezone';

export const DEFAULT_DATE_TIMEZONE = 'America/Los_Angeles';

export const resolveDateTimezone = (timezone?: string | null): string => {
  const trimmedTimezone = timezone?.trim();

  if (trimmedTimezone && moment.tz.zone(trimmedTimezone)) {
    return trimmedTimezone;
  }

  return DEFAULT_DATE_TIMEZONE;
};

export const nowInDateTimezone = (timezone?: string | null): Moment =>
  moment.tz(resolveDateTimezone(timezone));

export const momentInDateTimezone = (
  date: string | Date | Moment,
  timezone?: string | null
): Moment => moment.tz(date, resolveDateTimezone(timezone));

// True when `date` is three months or more before "now" (in the given
// timezone). Used to suppress stale lecture/exam dates from the UI.
export const isAtLeastThreeMonthsPast = (
  date: string | Date | Moment,
  timezone?: string | null
): boolean =>
  momentInDateTimezone(date, timezone).isSameOrBefore(
    nowInDateTimezone(timezone).subtract(3, 'months')
  );

export const parseDateKeyInDateTimezone = (
  dateKey: string,
  timezone?: string | null
): Moment =>
  moment
    .tz(dateKey, 'YYYY-MM-DD', true, resolveDateTimezone(timezone))
    .startOf('day');

export const buildDateInDateTimezone = ({
  year,
  month,
  day,
  timezone,
}: {
  year: number;
  month: number;
  day: number;
  timezone?: string | null;
}): Moment =>
  moment.tz({ year, month, day }, resolveDateTimezone(timezone)).startOf('day');
